module.exports = __webpack_public_path__ + "img/red_038.b3d6c417.png";